<template>
  <router-view />
</template>

<script>
export default {
  name: "others"
};
</script>